import React, { useState } from "react";
import { CustomDeleteModal } from "../../../DeleteModal/DeleteModal";
import styles from "./row-dropdown.module.scss";

export const RowDropdown = ({ isArchived = false, companyName = "" }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleItemClick = (action) => {
    if (action === "delete") {
      setShowDeleteModal(true);
    } else {
      console.log(`${action} clicked`);
    }
  };

  const handleDelete = async () => {
    // TODO: Implement actual delete logic
    console.log("Delete confirmed");
    setShowDeleteModal(false);
  };

  const handleKeyDown = (event, action) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleItemClick(action);
    }
  };

  if (isArchived) {
    const dropdownItems = [
      {
        id: "unarchive",
        label: "Unarchive Account",
        variant: "default",
        action: "unarchive",
      },
      {
        id: "delete",
        label: "Delete",
        variant: "danger",
        action: "delete",
      },
    ];

    return (
      <>
        <div className={styles.archivedDropdownWrapper}>
          <div className={styles.archivedDropdownMenu}>
            <div className={styles.archivedDropdownList}>
              {dropdownItems.map((item) => (
                <div key={item.id} className={styles.archivedDropdownListItem}>
                  <div
                    className={`${styles.archivedDropdownItem} ${
                      item.variant === "danger"
                        ? styles.archivedDropdownItemDanger
                        : styles.archivedDropdownItemDefault
                    }`}
                    role="menuitem"
                    tabIndex={0}
                    onClick={() => handleItemClick(item.action)}
                    onKeyDown={(e) => handleKeyDown(e, item.action)}
                    aria-label={item.label}
                  >
                    <div className={styles.archivedDropdownItemInner}>
                      <span className={styles.archivedDropdownItemText}>
                        {item.label}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <CustomDeleteModal
          show={showDeleteModal}
          hideModal={() => setShowDeleteModal(false)}
          deleteHeaderText={`Are you sure you want to delete ${companyName || "[Company Name]"}?`}
          customBody={
            <div className="d-flex flex-column align-items-start my-2 f-400 f-15">
              <div style={{ marginBottom: "20px" }}>
                Deletion permanently removes all company data. If the company returns, they must recreate their account.
              </div>
              <div>
                Trial history is kept, so no new trial will be granted. A plan is required on new account creation.
              </div>
            </div>
          }
          deleteFooterText=""
          deleteButtonText="Delete"
          deleteFunction={handleDelete}
          deleteType="generic"
        />
      </>
    );
  }

  const nonArchivedItems = [
    {
      id: "suspend",
      label: "Suspend Account",
      action: "suspend",
    },
    {
      id: "archive",
      label: "Archive Account",
      action: "archive",
    },
  ];

  return (
    <div className={styles.dropdownWrapper}>
      <div className={styles.dropdownMenu}>
        <div className={styles.dropdownList}>
          {nonArchivedItems.map((item, index) => (
            <React.Fragment key={item.id}>
              {index > 0 && (
                <div className={styles.dividerContainer}>
                  <div className={styles.dividerFull} style={{ borderTop: "1px solid rgba(235, 237, 241, 1)" }} />
                </div>
              )}
              <div className={styles.dropdownListItem}>
                <div
                  className={`${styles.dropdownItem} ${styles.dropdownItemDefault}`}
                  role="menuitem"
                  tabIndex={0}
                  onClick={() => handleItemClick(item.action)}
                  onKeyDown={(e) => handleKeyDown(e, item.action)}
                  aria-label={item.label}
                >
                  <div className={styles.dropdownItemInner}>
                    <span className={styles.dropdownItemText}>
                      {item.label}
                    </span>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};